import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import colorImage from 'assets/images/overview/foundation/color.svg';
import spacingImage from 'assets/images/overview/foundation/spacing.svg';
import styleImage from 'assets/images/overview/foundation/style.svg';
import typeImage from 'assets/images/overview/foundation/type.svg';

const images = {
  colorImage,
  spacingImage,
  styleImage,
  typeImage,
};

export default function FoundationPage() {
  const { data: language } = useSelector((state) => state.language);

  return (
    <div className="hot-container _p-5 _p-lg-8">
      <h1 className="_font-weight-bold _text-8">
        {language.foundationOverview.title}
      </h1>
      <div className="hot-row">
        <div className="hot-col-md-9">
          <p className="_mb-7">{language.foundationOverview.subhead}</p>
        </div>
      </div>
      <div className="hot-row _mt-7">
        {language.foundationOverview.items.map((item) => (
          <div
            className="hot-col-md-6 hot-col-lg-4 _mb-4 _mb-lg-5"
            key={item.id}
          >
            <hot-card class="hot-card--hover _h-full _rounded-lg">
              <hot-card-header>
                <img
                  src={images[item.image]}
                  alt={item.title}
                  className="_w-full"
                />
              </hot-card-header>
              <hot-card-body class="_p-4 _p-lg-8">
                <h2 className="_font-weight-bold _text-4">
                  <Link
                    to={item.link}
                    className="_stretched-link _text-decoration-none _text-gray-700"
                    title={item.title}
                  >
                    {item.title}
                  </Link>
                </h2>
                <p className="_text-gray-500 _mb-0">{item.text}</p>
              </hot-card-body>
            </hot-card>
          </div>
        ))}
      </div>
    </div>
  );
}
